import { Reducer } from "redux";

import {
  SkuInfoType,
  AddressItemType,
  SkuPriceType,
  FreightInfoType,
  ProductDetailType,
  SaleStockInfoType,
  InstallmentPlanItemType,
} from "../types";

import * as constants from "./constants";

export type StateType = {
  isInitReport: boolean;
  pageLoading: boolean;
  detail: ProductDetailType | null;
  skuPrice: SkuPriceType | null;
  currentSku: SkuInfoType | null;
  saleStockInfos: SaleStockInfoType[] | null;
  installmentPlans: InstallmentPlanItemType[] | null;
  spuScore: number | null;
  freightInfo: FreightInfoType | null;
  showSkuSelector: boolean;
  deepLink: string;
  defaultAddress: AddressItemType | null;
  // 是否已经初始化过第一次 默认地址 了。
  isInitDefaultAddress: boolean;
  skuAction: number;
  openAppLink: string;
};

const initState: StateType = {
  isInitReport: false,
  pageLoading: false,
  detail: null,
  skuPrice: null,
  currentSku: null,
  saleStockInfos: null,
  installmentPlans: null,
  spuScore: null,
  freightInfo: null,
  showSkuSelector: false,
  isInitDefaultAddress: false,
  defaultAddress: null,
  deepLink: "",
  skuAction: 1,
  openAppLink: "",
};

const reducer: Reducer<StateType> = (state = initState, action) => {
  switch (action.type) {
    case constants.SET_CURRENT_SKU:
      return {
        ...state,
        currentSku: action.payload.skuInfo,
      };
    case constants.SET_SPU_SCORE:
      return {
        ...state,
        spuScore: action.payload.score,
      };
    case constants.SET_DEFAULT_ADDRESS:
      return {
        ...state,
        isInitDefaultAddress: true,
        defaultAddress: action.payload.address,
      };
    case constants.SET_FREIGHT_INFO:
      return {
        ...state,
        freightInfo: action.payload,
      };
    case constants.SET_SKU_PRICE:
      return {
        ...state,
        skuPrice: action.payload,
      };
    case constants.SET_BASE_DETAIL:
      return {
        ...state,
        detail: action.payload,
      };
    case constants.SET_SKU_SELECTOR_VISIBLE:
      return {
        ...state,
        showSkuSelector: action.payload,
      };
    case constants.SET_SKU_ACTION:
      return {
        ...state,
        skuAction: action.payload,
      };
    case constants.SET_DEEP_LINK:
      return {
        ...state,
        deepLink: action.payload,
      };
    case constants.SET_SALE_STOCK_INFOS:
      return {
        ...state,
        saleStockInfos: action.payload,
      };
    case constants.SET_INSTALLMENT_PLANS:
      return {
        ...state,
        installmentPlans: action.payload,
      };
    case constants.SET_PAGE_LOADING:
      return {
        ...state,
        pageLoading: action.payload,
      };
    case constants.SET_IS_INIT_REPORT:
      return {
        ...state,
        isInitReport: action.payload,
      };
    case constants.RESET_STATE:
      return {
        ...initState,
      };
    case constants.SET_OPEN_APP_LINK:
      return {
        ...state,
        openAppLink: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
